module.exports = __webpack_public_path__ + "img/dons_cell_phone_belt.d345adfb.jpg";